import { postApiUrl } from "../../services/http-client";
import { getDiscount } from "../../services/manufacture.services";
import { createGeDefaultBuildingData, createGeDefaultBuildingDataForKlink } from "../building/edit_building/api.actions.getEditBuildingData";
import { createGetBuildingData } from "../building/building_style/buildingStyle.action";
import { createGetPricingDataForLeanto } from "../lean_building_pricing/api.actions.getPricingDataForLeanto";
import { createGetPricingData } from "../building_pricing/buildingPricing.action";
export const createCallPublicAPI = (deps) => {
	const { const_var } = deps;
	function CallPublicAPI() {
		let settingData = const_var.crmSetting;
		let apiData = "";
		apiData = { module_id: settingData.is_module_id };
		let apiUrl = settingData.api_post_url + "/api/v1/3d/edit-start";
		return (dispatch) => {
			return postApiUrl(apiUrl, apiData)
				.then(function (response) {
					dispatch({
						type: "CallPublicAPI",
						value: response
					});
				})
				.catch(function (error) {
					console.log(error);
				});
		};
	}

	return CallPublicAPI;
};
export const createSendDatatoServer = (deps) => {
	const { const_var, saveQuote } = deps;
	function sendDatatoServer(e) {
		return (dispatch, getState) => {
			dispatch({ type: "RAISETICKETS", response: "" });
			let postData = {
				api_token: const_var.crmSetting.api_token,
				user_id: const_var.crmSetting.login_user_id,
				ticket_title: "License Upgrade Ticket",
				ticket_description: "I want to access the Price Comparison feature. Please upgrade my license.",
				type: "feature_request"
			};
			return postApiUrl(const_var.crmSetting.api_post_url + "/api/v1/tickets/save", postData)
				.then(function (response) {
					if (response.data.status == true) {
						getState()?.screenShareReducer?.isSharingScreen && dispatch(saveQuote(response.data));
						dispatch({ type: "RAISETICKETS", response: response.data });
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		};
	}

	return sendDatatoServer;
};
export const createDiscountApi = (deps) => {
	const { params, const_var, discountBannerAction } = deps;
	const discountApi = (apiDiscountData, forAll, msnID) => {
		return (dispatch) => {
			getDiscount()
				.then((disResp) => {
					if (disResp?.data?.length) {
						const isSurcharge = const_var.stateData?.fetch_price_for?.surcharge;
						const isEdit = const_var.crmSetting?.is_Edit;
						const isSurchargeEditable = const_var.surcharge_amount_is_edit;
						if (isSurcharge && isEdit && !isSurchargeEditable) {
							const_var.UpdatedPriceData.surcharge_amount = undefined;
						}
						for (let j = 0; j < disResp.data.length; j++) {
							const offers = disResp.data[j]?.offers || [];
							for (let i = 0; i < offers.length; i++) {
								const offer = offers[i];
								offer.price_from = parseFloat(offer.price_from) || 0;
								offer.price_to = parseFloat(offer.price_to) || 0;
							}
						}
					}
					dispatch(discountBannerAction(disResp, forAll, msnID));
				})
				.catch((disError) => {
					let res = {
						data: {
							status: true,
							data: {
								results: []
							}
						}
					};
					dispatch({
						type: "discountBannerAction",
						value: res,
						forAll: "all",
						msnID: params.m_s_n
					});
					console.log("disError", disError);
				});
		};
	};

	return discountApi;
};
export const createApiActions = (deps) => {
	const geDefaultBuildingDataForKlink = createGeDefaultBuildingDataForKlink(deps);
	const geDefaultBuildingData = createGeDefaultBuildingData(deps);
	const CallPublicAPI = createCallPublicAPI(deps);
	const sendDatatoServer = createSendDatatoServer(deps);
	const discountApi = createDiscountApi(deps);
	const getBuildingData = createGetBuildingData(deps, { discountApi });
	const getPricingDataForLeanto = createGetPricingDataForLeanto(deps);
	const getPricingData = createGetPricingData(deps, { getPricingDataForLeanto });

	return {
		geDefaultBuildingDataForKlink,
		geDefaultBuildingData,
		getPricingData,
		getPricingDataForLeanto,
		CallPublicAPI,
		sendDatatoServer,
		getBuildingData,
		discountApi
	};
};
